/*
 * Takes in an array of consecutive TextNodes and returns a document fragment with `word` highlighted
 */
function highlight_text_nodes($nodes: Element[], word: string) {
	if (!$nodes.length) {
		return;
	}

	let text = "";

	// Concatenate the consecutive nodes to get the actual text
	for (let i = 0; i < $nodes.length; i++) {
		text += $nodes[i].textContent;
	}

	const $fragment = document.createDocumentFragment();
	let search = true;
	while (search) {
		// Tweak this if you want to change the highlighting behavior
		const index = text.toLowerCase().indexOf(word.toLowerCase());

		if (index === -1) {
			search = false;
			break;
		}

		// Split the text into [before, match, after]
		const before = text.slice(0, index);
		const match = text.slice(index, index + word.length);
		text = text.slice(index + word.length);

		// Create the <mark>
		const $mark = document.createElement("mark");
		$mark.className = "found";
		$mark.appendChild(document.createTextNode(match));

		// Append it to the fragment
		$fragment.appendChild(document.createTextNode(before));
		$fragment.appendChild($mark);
	}

	// If we have leftover text, just append it to the end
	if (text.length) {
		$fragment.appendChild(document.createTextNode(text));
	}

	// Replace the nodes with the fragment
	$nodes[0].parentNode?.insertBefore($fragment, $nodes[0]);

	for (let i = 0; i < $nodes.length; i++) {
		const $node = $nodes[$nodes.length - i - 1];
		$node.parentNode?.removeChild($node);
	}
}

/*
 * Highlights all instances of `word` in `$node` and its children
 */
export function highlight($node: Element, word: string) {
	const $children = $node.childNodes;
	let $current_run: Element[] = [];

	for (let i = 0; i < $children.length; i++) {
		const $child = $children[i];

		if ($child.nodeType === Node.TEXT_NODE) {
			// Keep track of consecutive text nodes
			$current_run.push($child as Element);
		} else {
			// If we hit a regular element, highlight what we have and start over
			highlight_text_nodes($current_run, word);
			$current_run = [];

			// Ignore text inside of our <mark>s
			if ($child.nodeType === Node.ELEMENT_NODE && ($child as HTMLElement).className !== "found") {
				highlight($child as Element, word);
			}
		}
	}

	// Just in case we have only text nodes as children
	if ($current_run.length) {
		highlight_text_nodes($current_run, word);
	}
}

/*
 * Removes all highlighted <mark>s from the given node
 */
export function unhighlight($node: Element) {
	const $marks: Element[] = [].slice.call($node.querySelectorAll("mark.found"));

	for (let i = 0; i < $marks.length; i++) {
		const $mark = $marks[i];

		// Replace each <mark> with just a text node of its contents
		if ($mark.childNodes[0].textContent) {
			$mark.parentNode?.replaceChild(
				document.createTextNode($mark.childNodes[0].textContent),
				$mark
			);
		}
	}
}
